export default __webpack_public_path__ + "static/media/skypad.26d6d547.png";